import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { fetchSiteSettingsPublic } from '../services/api';

export default function SiteFooter() {
  const [text, setText] = useState('Clipto. Not affiliated with Twitch.');
  const [footerLinks, setFooterLinks] = useState({
    termsOfService: true,
    privacyPolicy: true,
    contact: true,
  });

  useEffect(() => {
    let mounted = true;
    async function load() {
      try {
        let siteSettingsPromise;
        try {
          if (typeof fetchSiteSettingsPublic === 'function') {
            const maybe = fetchSiteSettingsPublic();
            if (maybe && typeof maybe.then === 'function') {
              siteSettingsPromise = maybe.catch(() => ({}));
            } else {
              siteSettingsPromise = Promise.resolve(maybe || {});
            }
          } else {
            siteSettingsPromise = Promise.resolve({});
          }
        } catch (e) {
          siteSettingsPromise = Promise.resolve({});
        }

        const data = await siteSettingsPromise;
        if (!mounted) return;
        if (data && data.footerText) setText(data.footerText);
        if (data && data.footerLinks) {
          setFooterLinks({
            termsOfService: typeof data.footerLinks.termsOfService === 'boolean' ? data.footerLinks.termsOfService : true,
            privacyPolicy: typeof data.footerLinks.privacyPolicy === 'boolean' ? data.footerLinks.privacyPolicy : true,
            contact: typeof data.footerLinks.contact === 'boolean' ? data.footerLinks.contact : true,
          });
        }
      } catch (e) {
        // ignore - keep default
      }
    }
    load();
    return () => { mounted = false; };
  }, []);

  return (
    <footer className="py-6 border-t border-dark-700">
      <div className="flex flex-col items-center gap-3 text-sm text-gray-500">
        <nav className="flex gap-6" aria-label="Footer navigation">
          {footerLinks.privacyPolicy && (
            <Link to="/privacy-policy" className="hover:text-gray-300 transition-colors">Privacy Policy</Link>
          )}
          {footerLinks.termsOfService && (
            <Link to="/terms-of-service" className="hover:text-gray-300 transition-colors">Terms of Service</Link>
          )}
          {footerLinks.contact && (
            <Link to="/contact" className="hover:text-gray-300 transition-colors">Contact</Link>
          )}
        </nav>
        <p>© {new Date().getFullYear()} {text}</p>
      </div>
    </footer>
  );
}
